// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"585":"TikTokApplication","593":"InstagramApplication"}[chunkId] || chunkId) + "." + {"585":"2dca64fb","593":"5434b9de","718":"5611e620","872":"04ca1b6f","978":"a5ffa854"}[chunkId] + ".js";
};